/** Formate un nombre de tokens selon la locale. */
export function u3207FormatTokenCount(value: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(value);
}

/** Affiche un pourcentage d'usage quota (null = illimité / N/A). */
export function u3207FormatUsagePercent(percent: number | null, locale: string): string | null {
  if (percent == null || Number.isNaN(percent)) return null;
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    maximumFractionDigits: 1,
  }).format(percent / 100);
}

/** Clamp 0–100 pour barre visuelle de quota. */
export function u3207QuotaBarWidthPercent(usagePercent: number | null): number {
  if (usagePercent == null || Number.isNaN(usagePercent)) return 0;
  return Math.min(100, Math.max(0, usagePercent));
}

/** Libellé usager affichable. */
export function u3207FormatUserLabel(user: {
  username: string;
  firstName?: string | null;
  lastName?: string | null;
}): string {
  const first = user.firstName?.trim() ?? '';
  const last = user.lastName?.trim() ?? '';
  const full = `${first} ${last}`.trim();
  return full || user.username;
}

/** Libellé code/nom : évite « TEST — TEST » quand code === name. */
export function u3207FormatCodeNameLabel(code: string, name: string): string {
  const c = code?.trim() ?? '';
  const n = name?.trim() ?? '';
  if (!c) return n;
  if (!n || c === n) return c;
  return `${c} — ${n}`;
}

/**
 * Affiche le quota en pourcentage d'usage uniquement.
 * Si quota null → illimité.
 */
export function u3207FormatQuotaUsage(params: {
  usedTokens: number;
  quotaMonthlyTokens: number | null;
  usagePercent: number | null;
  locale: string;
  unlimitedLabel: string;
}): string {
  const { quotaMonthlyTokens, usagePercent, locale, unlimitedLabel } = params;
  if (quotaMonthlyTokens == null) {
    return unlimitedLabel;
  }
  return u3207FormatUsagePercent(usagePercent, locale) ?? unlimitedLabel;
}
